import { SectionCard, SectionCardTitle } from "@/components";
import LeadershipImageGrid from "./ImageGrid";
import { LeadershipCards } from "./LeadershipCards";
import { Meta } from "@/components";


const OurLeadership = () => {
  return (
    <>
    <Meta
        title="Intron - Our Leadership"
    />
    <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-1/2 w-full lg:mt-25">
          <SectionCardTitle>Our Leadership</SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px]   text-justify  text-[#415667] mt-4">
            At Intron Life Sciences, our leadership team embodies decades of combined expertise in biotechnology, animal health, and sustainable innovation. 
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <LeadershipImageGrid />
        </div>
        </div>

      </div>
    </SectionCard>
    <LeadershipCards />
  </>
  );
};

export default OurLeadership;
